import { render, staticRenderFns } from "./Decelerometer.vue?vue&type=template&id=63da7b67&scoped=true&"
import script from "./Decelerometer.vue?vue&type=script&lang=js&"
export * from "./Decelerometer.vue?vue&type=script&lang=js&"
import style0 from "./Decelerometer.vue?vue&type=style&index=0&id=63da7b67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63da7b67",
  null
  
)

export default component.exports